module.exports = __webpack_public_path__ + "static/img/buty2_g.e64d72d5.webp";